<script setup>
import { computed } from 'vue';

const props = defineProps({
    valor: {
        type: [String, Number],
        default: '',
    },
    icone: {
        type: String,
        default: null,
    },
    semIcone: {
        type: Boolean,
        default: false,
    },
    cor: {
        type: String,
        default: null,
        validator: (value) =>
            value === null ||
            [
                'laranja',
                'roxo',
                'periwinkle',
                'lima',
                'verde-agua',
                'azul-claro',
                'rosa-velho',
                'verde',
                'rosa-claro',
                'magenta',
                'azul',
                'amarelo',
                'verde-sage',
            ].includes(value),
    },
    severidade: {
        type: String,
        default: null,
    },
    tooltip: {
        type: String,
        default: '',
    },
});

const paleta = {
    laranja: '#f0712f',
    roxo: '#c63de8',
    periwinkle: '#a7adf5',
    lima: '#c8f23a',
    'verde-agua': '#9fe0c8',
    'azul-claro': '#a8c4f0',
    'rosa-velho': '#d9b8b0',
    verde: '#8cc63d',
    'rosa-claro': '#f5b8c0',
    magenta: '#ef7ac0',
    azul: '#3aaae0',
    amarelo: '#f5d020',
    'verde-sage': '#9bbf8c',
};

const estilo = computed(() => {
    const base = { borderRadius: '9999px' };
    if (props.cor && paleta[props.cor]) {
        return { ...base, backgroundColor: paleta[props.cor], color: '#1f2937' };
    }
    return base;
});

const usaSeveridade = computed(() => !props.cor && props.severidade);
</script>

<template>
    <Tag :value="valor" :severity="usaSeveridade ? severidade : null" :style="estilo" v-tooltip.top="tooltip"
        class="tag-default font-semibold" style="padding: 0.15rem 0.4rem !important; font-size: 9px !important;">
        <template v-if="!semIcone" #icon>
            <i v-if="icone" :class="icone" class="text-xs mr-2" />
            <svg v-else class="tag-default__sparkle mr-2" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                <path
                    d="M12 0c.6 5.7 5.7 10.8 12 11.4v1.2C17.7 13.2 12.6 18.3 12 24c-.6-5.7-5.7-10.8-12-11.4v-1.2C6.3 10.8 11.4 5.7 12 0z" />
            </svg>
        </template>
    </Tag>
</template>

<style scoped>
.tag-default {
    line-height: 1;
}

.tag-default__sparkle {
    width: 1em;
    height: 1em;
    flex-shrink: 0;
}
</style>
